import React from 'react';
import { HeaderTabs } from '.';
import { type AudiSalesForceModuleSpecsFragment } from '../../../../api/fragments';
import AudiSalesForceModuleAuthorization from './AudiSalesForceModuleAuthorization';
import AudiSalesForceModuleMainDetails from './AudiSalesForceModuleMainDetails';

type AudiSalesForceModuleInnerPageProps = {
    activeTab: HeaderTabs;
    module: AudiSalesForceModuleSpecsFragment;
};

const AudiSalesForceModuleInnerPage = ({ activeTab, module }: AudiSalesForceModuleInnerPageProps) => {
    switch (activeTab) {
        case HeaderTabs.MainDetails:
            return <AudiSalesForceModuleMainDetails module={module} />;

        case HeaderTabs.Authorization:
            return <AudiSalesForceModuleAuthorization module={module} />;

        default:
            return null;
    }
};

export default AudiSalesForceModuleInnerPage;
